export default "__VITE_ASSET__CW5UEfKN__"